<template>
  <div v-if="showMenu" class="map-kit-measure-menu">
    <Button
      icon="fas fa-ruler-horizontal"
      severity="contrast"
      size="small"
      text
      label="Line"
      class="map-kit-measure-item"
      :class="{ 'toolbar-item-selected': measureType === 'line' }"
      @click="startMeasure('line')"
    />
    <Button
      icon="fas fa-draw-polygon"
      severity="contrast"
      size="small"
      text
      label="Area"
      class="map-kit-measure-item"
      :class="{ 'toolbar-item-selected': measureType === 'area' }"
      @click="startMeasure('area')"
    />
    <Button
      icon="fas fa-eraser"
      severity="contrast"
      size="small"
      text
      label="Clear"
      class="map-kit-measure-item"
      @click="onClear"
    />
  </div>
</template>

<script setup lang="ts">
import Button from 'primevue/button';

import { useMeasurement } from '@/composables/useMeasurement';

defineProps<{
  showMenu: boolean;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const { measureType, startMeasure, clearMeasurements } = useMeasurement();

const onClear = () => {
  clearMeasurements();
  emit('close');
};
</script>
